<!-- 投放排行 -->
<template>
<div id="dashboard">
	<!-- 标题 -->
	<div class="page-title">投放排行</div>
	
	<!-- 装表格的盒子 -->
	<div style="margin-top: 10px;display: flex;flex-wrap: wrap;">
		<div v-for="(item_t,index_t) in tableShowData" :key="index_t" style="padding: 12px 12px 50px;">
			<div style="font-size: 18px;color: #2c2c2c;margin-bottom: 10px;">{{item_t.title}}</div>
			<div style="position: relative;">
				<!-- 表头 -->
				<div class="table-th" style="">
					<div  v-for="(item,index) in rableTitle" :key="index" >
						<div class="table-th-cell" 
						:style="{'width':item.width + 'px','min-width':item.min_width + 'px'}">
							{{item.title}}
						</div>
					</div>
				</div>
				
				<!-- 表格内容 -->
				<div v-for="(item,index) in item_t.showData" :key="item.id" class="table-td" >
					<!-- 序号 -->
					<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px','min-width':rableTitle[0].min_width + 'px'}">
						{{index + 1}}
					</div>
					<!-- 投手 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px','min-width':rableTitle[1].min_width + 'px'}">
						{{item.user_name}}
					</div>
					<!-- 当日ROI -->
					<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px','min-width':rableTitle[2].min_width + 'px'}">
						{{item.today_roi}}
					</div>
					<!-- 消耗 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px','min-width':rableTitle[3].min_width + 'px'}">
						{{item.used_money}}
					</div>
					<!-- 回款 -->
					<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px','min-width':rableTitle[4].min_width + 'px'}">
						{{item.left_money | tableToFixed}}
					</div>
					<!-- ROI -->
					<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px','min-width':rableTitle[5].min_width + 'px'}">
						{{item.roi}}
					</div>
				</div>
			</div>
			
		</div>
		
		
		
	</div>
</div>
</template>

<script>
import { dashboardRank } from '@/request/api'
export default {
	name: 'fansRank',
	data(){
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"序号",width:60, min_width: 50,sort_:90,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"投手",width:85, min_width: 70, sort_:89,},
				{title:"当日ROI",width:80, min_width: 50, sort_:88,},
				{title:"消耗",width:120, min_width: 85, sort_:87,},
				{title:"回款",width:120, min_width: 85, sort_:86,},
				{title:"ROI",width:80, min_width: 50, sort_:85,},
			],
			tableShowData: [
				{title:"昨天消耗榜", showData:[]},
				{title:"前天消耗榜", showData:[]},
				{title:"大前天消耗榜", showData:[]},
				{title:"本周消耗榜", showData:[]},
				{title:"上周消耗榜", showData:[]},
				{title:"上上周消耗榜", showData:[]},
				{title:"本月消耗榜", showData:[]},
				{title:"上月消耗榜", showData:[]},
				{title:"上上月消耗榜", showData:[]},
				
			], // 展示表格数据
		}
	},
	mounted(){
		let that = this
		
		// 对表格内容的宽度进行计算
		console.log("对表格内容的宽度进行计算",document.body.clientWidth)
		// alert(document.body.clientWidth)
		let www = document.body.clientWidth - 60 // 60是内边距
		let t_w = Math.floor((www/3) - 30)
		// 序号、投手的宽度
		if(www < 1700){
			that.rableTitle[0].width = 50
			that.rableTitle[1].width = 70
		}
		else {
			that.rableTitle[0].width = 60
			that.rableTitle[1].width = 85
		}
		let c_w = t_w - that.rableTitle[0].width - that.rableTitle[1].width // 减去序号和投手的宽
		that.rableTitle[2].width = Math.floor(c_w*0.2)
		that.rableTitle[5].width = Math.floor(c_w*0.2)
		that.rableTitle[3].width = Math.floor(c_w*0.3)
		that.rableTitle[4].width = Math.floor(c_w*0.3)
		console.log("that.rableTitle",that.rableTitle);
		console.log("t_w",t_w);
		dashboardRank().then(res=>{
			console.log('获取数据',res)
			if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
				let data = res.data.data.list
				that.tableShowData.forEach((res,index)=>{
					switch(res.title)
					{
						case "昨天消耗榜":
							res.showData = data.yesterday
							break;
						case "前天消耗榜":
							res.showData = data.last_yesterday
							break;
						case "大前天消耗榜":
							res.showData = data.last_last_yesterday
							break;
						case "本周消耗榜":
							res.showData = data.this_week
							break;
						case "上周消耗榜":
							res.showData = data.last_week
							break;
						case "上上周消耗榜":
							res.showData = data.last_last_week
							break;
						case "本月消耗榜":
							res.showData = data.this_month
							break;
						case "上月消耗榜":
							res.showData = data.last_month
							break;
						case "上上月消耗榜":
							res.showData = data.last_last_month
							break;
						
					}
				})
				console.log("that.tableShowData",that.tableShowData)
			}
			else {
				if(res.data.code === 401){ // 未登录
					localStorage.removeItem("access_token");
					that.$router.replace({name: 'login',params: {type:'not_log'}})
				}
				else {
					that.$message.error(`其他错误：${res.data.msg}`);
				}
			}
		})
	},
	methods:{
		
	},
	filters: {
		tableToFixed(value){
			// console.log("过滤器",value)
			// let v = Number(value)
			let ttt
			if(value){
				
				ttt = Number(value).toFixed(2) // 不转化成数字类型的数据的话，遇到字符串的值就会报错
			}
			else {
				ttt = 0
			}
			return ttt
			// return v.toFixed(2)
		}
	}
}
</script>

<style scoped>
.page-title {
	text-align: left;
	font-weight: 500;
	font-size: 24px;
}

/* 表格部分的样式 */
.table-th {
	position:sticky;
	top: 65px;
	z-index:3;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #e8e8e8;
	background-color: #fbfbfb;
}
.table-th-cell {
	display: flex;
	align-items: center;
	padding: 10px 8px;
	cursor: default;
	color: #060606;
	flex-shrink: 0;
	/* background-color: #fbfbfb; */
	border-bottom: none;
	user-select: none;
	font-size: 13px;
}

.table-td {
	
	display: flex;
	align-items: center;
	width: 100%;
	border-bottom: 1px solid #e8e8e8;
}
.table-td:hover {
	background-color: #eff9ff;
}
.table-td:hover .table-td-cell-sticky{
	background-color: #eff9ff;
}
.table-td-cell {
	padding: 10px 8px;
	flex-shrink: 0;
	cursor: default;
	word-break:break-all;
	color: rgba(0, 0, 0, 0.65);
	min-height: 40px;
	font-size: 13px;
	/* overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis; */
}
</style>